import NotFound from './NotFoundPage'

export default NotFound;
